import type { StaffBootstrap } from '../shared/types';

export function staffIdentityLabel(staff: Pick<StaffBootstrap, 'displayName' | 'role' | 'environment'>): string {
	const role = staff.role.replaceAll('_', ' ').replace(/\b\w/gu, (letter) => letter.toUpperCase());
	const identity = `${staff.displayName} · ${role}`;
	return staff.environment === 'production' ? identity : `${identity} · ${staff.environment}`;
}
